export default "__VITE_ASSET__BHpn$Q6H__"